export default function BuyMeACoffee() {
	return (
		<a href="https://buymeacoffee.com/democratiq" target="_blank" className="buy-me-a-coffee">
			{/* Self-hosted. It used to come from img.buymeacoffee.com, which handed every
			    visitor's IP address to a third party before the consent banner had asked
			    anything — the same problem as the Google Fonts and FontAwesome requests removed
			    in Phase 4, and the last one on the site.

			    The supporter-count badge was stripped when the file was saved. It is the one
			    part of that button that goes stale offline, and a permanently wrong number on
			    the page is worse than no number. Regenerate with the recipe in
			    public/buy-me-a-coffee.svg's sibling note in web/README.md. */}
			<img src="/buy-me-a-coffee.svg" alt="Buy Me a Coffee" width="184" height="50"/>
		</a>
	);
}
